import { render, staticRenderFns } from "./apartment-register.vue?vue&type=template&id=20dc9800&scoped=true&"
import script from "./apartment-register.vue?vue&type=script&lang=js&"
export * from "./apartment-register.vue?vue&type=script&lang=js&"
import style0 from "./apartment-register.vue?vue&type=style&index=0&id=20dc9800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc9800",
  null
  
)

export default component.exports